import { useTranslation } from 'react-i18next'
import { ProofCard, Metric, Field, Etiqueta, Rastro, type ProofStat } from '../../brand'

// Números da execução real (fonte acima) — os mesmos de products.autonomySuite.genesis.demo.metrics; aqui em forma numérica para a contagem.
const STATS_NUM: Array<Omit<ProofStat, 'label'>> = [{ to: 147 }, { to: 21, suffix: '/21' }, { to: 0 }, { to: 8.2, decimals: 1, suffix: '/10' }]

/** O que aconteceu nesta execução: frase com os números em mono + cartão que conta de zero + maturidade da plataforma (6 métricas com fonte). */
export function ProofSection({ withMaturity = true }: { withMaturity?: boolean }) {
  const { t } = useTranslation()
  const sentence = t('model.proof.sentence', { returnObjects: true }) as string[]
  const card = t('model.proof.card', { returnObjects: true }) as { when: string; title: string; body: string; timingLabel: string; timingUnit: string; stats: string[] }
  const proof = t('products.proof', { returnObjects: true }) as { title: string; disclaimer: string; items: Array<{ value: string; label: string; value_source?: string }> }
  const stats: ProofStat[] = STATS_NUM.map((s, i) => ({ ...s, label: card.stats[i] }))
  return (
    <>
      <div className="z-proof">
        <div>
          <p className="z-proof__texto">{sentence.map((s, i) => (i % 2 ? <span key={i} className="z-proof__num">{s}</span> : <span key={i}>{s}</span>))}</p>
          <Rastro source={{ label: t('model.proof.source') }} />
        </div>
        <ProofCard copy={{ when: card.when, title: card.title, body: card.body, timingLabel: card.timingLabel, timingUnit: card.timingUnit, timingTo: 7 }} stats={stats} />
      </div>
      {withMaturity && (
        <>
          <Etiqueta as="p">{proof.title}</Etiqueta>
          <Field columns={3}>
            {proof.items.map((m, i) => <Metric key={i} value={m.value} label={m.label} source={{ label: m.value_source ?? proof.disclaimer }} withRastro={false} />)}
          </Field>
        </>
      )}
    </>
  )
}
